export const classes = {
  mainContainer: 'managed-permission-view-main-container',
  tableContainer: 'managed-permission-view-table-container',
  outerLabel: 'managed-permission-view-outer-label',
  innerLabel: 'managed-permission-view-inner-label',
  iconContainer: 'managed-permission-view-icon-container',
}
